export enum LifeEditContext {
    Defenses = 'defenses',
    ContractInfo = 'contractInfo',
    ContractDuration = 'contractDuration',
    PaymentSchedule = 'paymentSchedule',
    ContactInfo = 'contactInfo',
    TaxInformation = 'taxInformation',
    LifestyleAndHealth = 'lifestyleAndHealth',
    Beneficiaries = 'beneficiaries',
}
